import clsx from "clsx";
import { LinkProps, useNavigate } from "react-router-dom";
import { LocaleTranslationResource, useTranslate } from "ui/locale";
import { MainDrawerLinkRoot, LinkIcon } from "./MainDrawerLink.styles";
import { JSXElementConstructor } from "react";

export type MainDrawerLinkProps = Pick<LinkProps, "className" | "to" | "style"> & {
    label: LocaleTranslationResource;
    icon: JSXElementConstructor<Record<string, unknown>>;
    onClick?: () => void;
    closeDrawer: () => void;
};

function MainDrawerLink({ className, label, to, closeDrawer, icon, onClick, ...rest }: MainDrawerLinkProps) {
    const translate = useTranslate();
    const navigate = useNavigate();

    function handleClick() {
        if (onClick) {
            onClick();
            return;
        } else {
            setTimeout(() => navigate(to), 100);
        }
        closeDrawer();
    }

    return (
        <MainDrawerLinkRoot variant="h3Strong" onClick={handleClick} className={clsx("main-drawer-link", className)} {...rest}>
            <LinkIcon as={icon}></LinkIcon>
            <div>{translate(label).capitalize()}</div>
        </MainDrawerLinkRoot>
    );
}

export default MainDrawerLink;
